var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.239 39.0146H31.6655V35.1543C31.6634 33.4486 30.9849 31.8133 29.7788 30.6072C28.5727 29.401 26.9374 28.7225 25.2317 28.7205H17.5111C15.8053 28.7225 14.17 29.401 12.9639 30.6072C11.7578 31.8133 11.0793 33.4486 11.0772 35.1543V39.0146H8.50371V35.1543C8.50643 32.7662 9.45629 30.4768 11.1449 28.7881C12.8335 27.0995 15.123 26.1497 17.5111 26.1469H25.2317C27.6197 26.1497 29.9092 27.0995 31.5978 28.7881C33.2864 30.4768 34.2363 32.7662 34.239 35.1543V39.0146ZM7.21694 8.13222C6.87567 8.13222 6.54838 8.26779 6.30706 8.5091C6.06575 8.75042 5.93018 9.07771 5.93018 9.41898V20.9999H8.50371V9.41898C8.50371 9.07771 8.36814 8.75042 8.12682 8.5091C7.88551 8.26779 7.55821 8.13222 7.21694 8.13222Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93018 2.98515V5.55869H12.364V14.566C12.364 16.9549 13.313 19.246 15.0022 20.9352C16.6914 22.6244 18.9825 23.5734 21.3714 23.5734C23.7603 23.5734 26.0513 22.6244 27.7405 20.9352C29.4297 19.246 30.3787 16.9549 30.3787 14.566V5.55869H36.8125V2.98515H5.93018ZM14.9375 5.55869H27.8052V9.41898H14.9375V5.55869ZM21.3714 20.9999C19.665 20.9999 18.0285 20.322 16.822 19.1155C15.6154 17.9089 14.9375 16.2724 14.9375 14.566V11.9925H27.8052V14.566C27.8052 16.2724 27.1273 17.9089 25.9208 19.1155C24.7142 20.322 23.0777 20.9999 21.3714 20.9999Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdu);
export default __webpack_public_path__ + "static/media/edu.a3f056521dff075901b650b296589d21.svg";
export { ForwardRef as ReactComponent };